import { defineComponent as _defineComponent } from 'vue'
import BCXDottedCollapsible from '@/components/molecules/BCXDottedCollapsible.vue';
import { useVModel, watchImmediate } from '@vueuse/core';
import BCXTextArea from '@/components/molecules/forms/BCXTextArea.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import BCXMultiselectSection, { BCXExtendedDropdownItem } from '@/components/molecules/forms/BCXMultiselectSection.vue';
import {
  computed, PropType, ref, toRefs
} from 'vue';
import useUser from '@/mixins/useUser';
import { ProjectOffer } from '@/models/MyProjects';
import BCXMultiselectFilter from '@/components/molecules/BCXMultiselectFilter.vue';
import BCXCheckbox from '@/components/molecules/forms/BCXCheckbox.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsOfferDetailAnswerBox',
  props: {
  isOpen: Boolean,
  isLoading: {
    type: Boolean,
    default: false
  },
  offer: {
    type: Object as PropType<ProjectOffer>,
    required: true,
  },
  mode: {
    type: String as PropType<'accept' | 'reject'>,
    required: true
  }
},
  emits: ['reject', 'accept', 'block-user'],
  setup(__props, { emit }) {

const props = __props;



const { mode, offer } = toRefs(props);



const { tUserFallback: tOfferer } = useUser(offer.value?.creator); // todo: offer-user
const { tUserFallback: t } = useUser('self'); // todo: offer-user

const { selectedProjectWithOffers } = useMyProjects();
const isOpenVM = useVModel(props, 'isOpen');

const { isNarrow } = useMyProjects();

const filterValues = computed(() => (mode.value === 'reject'
  ? t('my-projects.offers-detail.reject-box.reason-options')
  : t('my-projects.offers-detail.reject-box.accept-options')));

const blockOffers = ref(false);

const reasons = computed(() => Object.entries(filterValues.value).map(([key, value]) => ({
  label: value,
  value: key
})) as BCXExtendedDropdownItem[]);

const selectedOptions = ref<string[]>([]);

const message = ref('');

const reasonsTitle = computed(() => t((selectedOptions.value.length > 0
  ? 'my-projects.offers-detail.reject-box.reasons-selected'
  : 'my-projects.offers-detail.reject-box.reasons')));

watchImmediate(mode, (mode) => {
  const title = selectedProjectWithOffers.value?.project?.title ?? '?';
  message.value = mode === 'reject'
    ? `${t('my-projects.offers-detail.reject-box.message-reject_USERTYPE', { title })}`
    : `${t('my-projects.offers-detail.reject-box.message-accept_USERTYPE', { title })}`;
  selectedOptions.value = [];
  blockOffers.value = false;
});

const getCheckboxProperties = () => Object.fromEntries(
  Object.keys(filterValues.value).map((reasonKey) => [reasonKey, !!selectedOptions.value.includes(reasonKey)])
);

const reject = () => {
  emit('reject', {
    message: message.value,
    ...getCheckboxProperties(),
  });

  if (blockOffers.value) {
    emit('block-user');
  }
};

const accept = () => {
  const { hoursPerWeekChanged, remoteWorkChanged, startDateChanged } = offer.value;
  emit('accept', {
    message: message.value,
    ...getCheckboxProperties(),
    hoursPerWeekChanged,
    remoteWorkChanged,
    startDateChanged,
  });
};


return { __sfc: true,props, mode, offer, emit, tOfferer, t, selectedProjectWithOffers, isOpenVM, isNarrow, filterValues, blockOffers, reasons, selectedOptions, message, reasonsTitle, getCheckboxProperties, reject, accept, BCXDottedCollapsible, BCXTextArea, BCXButton, BCXMultiselectSection, BCXMultiselectFilter, BCXCheckbox, BCXMarkdown }
}

})